import styled from 'styled-components';

export const UploadInvoiceContent = styled.div`
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media only screen and (max-width: 768px) {
    padding: 16px 20px;
    gap: 16px;
  }
`;

export const DropZone = styled.div<{ $isDragging: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 24px;
  border: 2px dashed
    ${({ $isDragging, theme }) =>
      $isDragging ? theme.color.ui.primary : theme.color.ui.shade2};
  border-radius: 3px;
  background-color: ${({ $isDragging, theme }) =>
    $isDragging ? `${theme.color.ui.primary}12` : theme.color.bg.primary};
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
  user-select: none;

  &:hover {
    border-color: ${({ theme }) => theme.color.ui.primary};
    background-color: ${({ theme }) => `${theme.color.ui.primary}08`};
  }

  svg.upload-icon {
    color: ${({ $isDragging, theme }) =>
      $isDragging ? theme.color.ui.primary : theme.color.text.quaternary};
    transition: color 0.2s ease;
  }

  @media only screen and (max-width: 768px) {
    padding: 28px 16px;
    gap: 8px;
  }
`;

export const DropZoneLabel = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.text.primary};
  text-align: center;
  margin: 0;
`;

export const DropZoneSubLabel = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.color.text.quaternary};
  text-align: center;
  margin: 0;
`;

export const DropZoneSeparator = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.color.text.quaternary};
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  border: 1px solid ${({ theme }) => theme.color.ui.shade1};
  border-radius: 3px;
  padding: 16px;

  svg {
    min-width: 32px;
  }

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;

    h3 {
      font-size: 14px;
      font-weight: 700;
      margin: 0;
    }

    p {
      font-size: 13px;
      margin: 0;
      color: ${({ theme }) => theme.color.text.quaternary};
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 10px;
    gap: 10px;
  }
`;

export const HelpText = styled.p`
  font-size: 13px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.color.text.quaternary};

  a {
    font-weight: 700;
    color: ${({ theme }) => theme.color.text.secondary};
  }
`;

// Bloco exibido quando o PDF está protegido por senha e nenhum documento já
// cadastrado abriu (código 1102): pede o CPF/CNPJ do titular da conta inline,
// em vez de fechar o modal e mandar o usuário para o tutorial de remoção de senha.
export const PasswordPromptForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

export const PasswordPromptIcon = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.color.ui.orange};
`;

export const PasswordPromptTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.color.text.secondary};
`;

export const PasswordPromptText = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.color.text.quaternary};
`;

export const PasswordInput = styled.input<{ $hasError?: boolean }>`
  width: 100%;
  padding: 12px 14px;
  font-size: 16px;
  border: 1px solid
    ${({ $hasError, theme }) =>
      $hasError ? theme.color.ui.danger : theme.color.ui.shade2};
  border-radius: 3px;
  text-align: center;
  letter-spacing: 1px;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.ui.primary};
  }
`;

export const PasswordPromptError = styled.p`
  font-size: 13px;
  margin: 0;
  color: ${({ theme }) => theme.color.ui.danger};
`;

export const PasswordPromptActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  button {
    flex: 1;
  }
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: ${({ theme }) => theme.color.text.quaternary};
  text-decoration: underline;
`;
